import PropTypes from "prop-types";
//import MaterialDescriptorBase from "react-three-renderer/lib/descriptors/Material/MaterialDescriptorBase";
//let MaterialDescriptorBase = (()=>{}) as any;
class MaterialDescriptorBase {
}
export class CustomMaterialDescriptor extends MaterialDescriptorBase {
    constructor(react3RendererInstance) {
        super(react3RendererInstance);
        this.hasProp("material", {
            type: PropTypes.object,
            update: this.triggerRemount,
            default: undefined,
        });
    }
    construct(props) {
        return props.material;
    }
}
